module.exports = __webpack_public_path__ + "static/media/blue2.b3bec23c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/blue2.svg
// module id = 1329
// module chunks = 31